import { GifsResult } from '@giphy/js-fetch-api'
import { IGif } from '@giphy/js-types'
import { useState } from 'react'

type ChannelEndpoint = {
    results: IGif[]
    next: string | null
}

// the channel endpoint works with offset, so just ignore the next and use offset
export const convertToPagination = (result: ChannelEndpoint, offset: number) => {
    const { results: data = [] } = result
    const count = data.length
    return {
        data,
        pagination: {
            count,
            total_count: Infinity,
            offset,
        },
        meta: {
            msg: '',
            response_id: '',
            status: 200,
        },
    }
}

/**
 * fetch gifs by tracking gifs in state
 * allowing use of offset based on gifs.length and also knowing when
 * fetching is done regardless if channel api or public api
 */
const useFetchGifs = ({
    initialGifs = [],
    fetchGifs,
}: {
    initialGifs?: IGif[]
    fetchGifs: (offset: number) => Promise<GifsResult>
}) => {
    const [gifs, setGifs] = useState<IGif[]>(initialGifs)
    const [doneFetching, setDoneFetching] = useState(false)
    const doFetch = async () => {
        if (doneFetching) {
            return
        }
        let result = await fetchGifs(gifs.length)
        // check if we're using the channel endpoint with results instead of data
        const channelEndpoint = result as unknown as ChannelEndpoint
        if (channelEndpoint.results) {
            result = convertToPagination(channelEndpoint, gifs.length)
        }
        const { data, pagination } = result
        const allGifs = [...gifs, ...data]
        // if we use the public api we won't have to make an extra request
        const regularAPIDone = allGifs.length === pagination.total_count
        // we will have had to make an extra request to get an empty response
        const channelAPIDone = !data.length
        setDoneFetching(regularAPIDone || channelAPIDone)
        setGifs(allGifs)
    }
    return { doneFetching, doFetch, gifs }
}

export default useFetchGifs
